// @ts-nocheck
import createReactClass from 'create-react-class';
import * as core from '@/core';
import * as compPanelInfra from '@/compPanelInfra';
import wixappsDesignSubComponentsPanel from './wixappsDesignSubComponentsPanel';

// eslint-disable-next-line react/prefer-es6-class
export default createReactClass({
  displayName: 'WixappsDesignPanel',

  mixins: [core.mixins.editorAPIMixin, compPanelInfra.panelSwitcherMixin],

  getDefaultProps() {
    return {
      backButtonLabel: 'list_design_panel_back_button_label',
    };
  },

  getInitialPanelClass() {
    return wixappsDesignSubComponentsPanel;
  },
});
